import { render, staticRenderFns } from "./VPanel.vue?vue&type=template&id=707e3666&scoped=true&"
import script from "./VPanel.vue?vue&type=script&lang=js&"
export * from "./VPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "707e3666",
  null
  
)

export default component.exports